import { c as _c } from "react/compiler-runtime";
import { resolvePagePath } from "@/utils/path";
import { baseAppDirname } from "@/config/constants";
import ClientBreadcrumbProvider from "./breadcrumb-provider";
import { addBreadcrumb } from "../../lib/breadcrumbs";
import { renderComponent } from "@/utils/jsx";
type Props = Parameters<typeof ClientBreadcrumbProvider>[0];
export default function BreadcrumbProvider(t0) {
  const $ = _c(12);
  let children;
  let icon;
  let menu;
  let params;
  let props;
  if ($[0] !== t0) {
    let {
      icon: t1,
      params: t2,
      menu: _menu,
      children: t3,
      ...t4
    } = t0;
    icon = t1;
    params = t2;
    children = t3;
    props = t4;
    icon = renderComponent(icon, {
      className: "size-[1em]"
    });
    menu = _menu?.map(t5 => {
      const {
        icon: _icon,
        href,
        ...props_0
      } = t5;
      return {
        ...props_0,
        icon: renderComponent(_icon, {
          className: "size-[1em]"
        }),
        href: href ?? resolvePagePath(props_0.dirname, params, baseAppDirname)
      };
    });
    addBreadcrumb({
      icon,
      menu,
      ...props
    }, params);
    $[0] = t0;
    $[1] = children;
    $[2] = icon;
    $[3] = menu;
    $[4] = params;
    $[5] = props;
  } else {
    children = $[1];
    icon = $[2];
    menu = $[3];
    params = $[4];
    props = $[5];
  }
  let t1;
  if ($[6] !== children || $[7] !== icon || $[8] !== menu || $[9] !== params || $[10] !== props) {
    t1 = <ClientBreadcrumbProvider {...props} icon={icon} menu={menu} params={params} children={children} />;
    $[6] = children;
    $[7] = icon;
    $[8] = menu;
    $[9] = params;
    $[10] = props;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  return t1;
}